import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { translateAggregationFunction } from 'modules/reports/lib/Constants'

interface Props {
  fieldType: FieldType
}

const AggregationInfo = ({ fieldType }: Props) => {
  const value = fieldType.form.get('function').value

  return (
    <Box flexDirection="row">
      <Text.Normal color="grey1000" size="200" weight="medium">
        {i18n.t('custom_reports.ability_labels.aggregate_by')}:&nbsp;
      </Text.Normal>
      <Text.Normal color="grey1000" size="200">
        {translateAggregationFunction(value)}
      </Text.Normal>
    </Box>
  )
}

export default observer(AggregationInfo)
